import { RootState } from '@reducers';
import { UserRoles } from '@models/User';

export const selectAuth = (state: RootState) => state.authReducer;
export const selectCurrentUser = (state: RootState) => selectAuth(state).currentUser;
export const selectIsFrontline = (state: RootState) => selectCurrentUser(state)?.role === UserRoles.Frontline;
export const selectIsCustomer = (state: RootState) => selectCurrentUser(state)?.role === UserRoles.Customer;
export const selectIsInsurer = (state: RootState) => selectCurrentUser(state)?.role === UserRoles.Insurer;
